import type { FC, ReactNode } from 'react';
import React from 'react';
import { cx } from '@/styled-system/css';
import { textOverflow } from './textOverflow.styles';

type TextOverflowProps = {
  children?: ReactNode;
  htmlTag?: keyof JSX.IntrinsicElements;
  className?: string;
};

const TextOverflow: FC<TextOverflowProps> = ({ children = null, htmlTag: CustomTag = 'div', className = null }) => {
  return <CustomTag className={cx(textOverflow, className)}>{children}</CustomTag>;
};

export default TextOverflow;
